/**
 * The side list of your teams, with your role in each; making a team; joining one with a
 * pasted invite link (of this server).
 */
import { For, createSignal, type JSX } from "solid-js";
import { parseInviteLink } from "../client/space";
import { toast } from "../shared/toast";
import { usePages } from "./context";
import { NewTeam } from "./NewTeam";

/** The team list; `current` is the team shown. */
export function TeamList(props: { current: string | null }): JSX.Element {
  const { accounts, server, go } = usePages();
  const [link, setLink] = createSignal("");
  /** Opens the pasted invite's page (another server's link opens there). */
  const join = () => {
    const invite = parseInviteLink(link());
    if (!invite) return toast("That is not an invite link: it looks like http://server/join/<code>", "error");
    setLink("");
    if (invite.server !== server) return location.assign(`${invite.server}/join/${invite.code}`);
    void accounts.offer(invite);
    go({ page: "join", code: invite.code });
  };
  return (
    <aside class="dash-side">
      <h3>Teams</h3>
      <nav class="team-list">
        <For each={accounts.me(server)?.teams ?? []}>
          {(team) => (
            <a
              href={`/t/${team.id}`}
              class="team-link"
              data-team={team.id}
              data-team-role={team.role}
              aria-current={props.current === team.id ? "page" : undefined}
              onClick={(e) => {
                e.preventDefault();
                go({ page: "team", team: team.id });
              }}
            >
              <span>{team.name}</span>
              <span class="muted small">{team.role}</span>
            </a>
          )}
        </For>
      </nav>
      <NewTeam id="new-team" />
      <form
        class="row-inline"
        onSubmit={(e) => {
          e.preventDefault();
          join();
        }}
      >
        <input class="field" id="join-link" placeholder="Paste an invite link" value={link()} onInput={(e) => setLink(e.currentTarget.value)} />
        <button type="submit" class="btn" id="join-link-go">
          Join
        </button>
      </form>
    </aside>
  );
}
